import { render, staticRenderFns } from "./checkouts.vue?vue&type=template&id=c4486f8a&scoped=true&"
import script from "./checkouts.vue?vue&type=script&lang=ts&"
export * from "./checkouts.vue?vue&type=script&lang=ts&"
import style0 from "./checkouts.vue?vue&type=style&index=0&id=c4486f8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4486f8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
